import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router';
import { useAuth } from './contexts/AuthContext';
import Dashboard from './pages/Dashboard';
import GamificationDashboard from './components/GamificationDashboard';
import AlertingConfig from './components/AlertingConfig';
import MonitorDetailsRouter from './components/MonitorDetailsRouter';
import PublicMonitorStatus from './components/PublicMonitorStatus';
import { AuthPage } from './pages/AuthPage';
import { AuthCallbackPage } from './pages/AuthCallbackPage';
import { FirstLoginSetup } from './components/auth/FirstLoginSetup';
import { ProfilePage } from './pages/ProfilePage';
import { AdminUsersPage } from './pages/AdminUsersPage';
import Layout from './components/Layout';
import DocsPage from './pages/DocsPage';

const AppRouter: React.FC = () => {
  const { isAuthenticated, user, loading, requiresFirstLoginSetup } = useAuth();

  // Show loading spinner while checking authentication
  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-base-200">
        <div className="text-center">
          <span className="loading loading-spinner loading-lg text-primary"></span>
          <p className="mt-4 text-base-content/70">Loading...</p>
        </div>
      </div>
    );
  }

  return (
    <Router>
      <Routes>
        {/* Public routes */}
        <Route path="/login" element={
          !isAuthenticated || !user ? <AuthPage /> : <Navigate to="/dashboard" replace />
        } />
        <Route path="/public/monitor/:id" element={<PublicMonitorStatus />} />
        {/* Keycloak SSO landing page - must be reachable before authentication */}
        <Route path="/auth/callback" element={<AuthCallbackPage />} />
        
        {/* Protected routes */}
        <Route path="/*" element={
          !isAuthenticated || !user ? (
            <Navigate to="/login" replace />
          ) : requiresFirstLoginSetup ? (
            <FirstLoginSetup key="first-login-setup" />
          ) : (
            <Layout>
              <Routes>
                <Route path="/" element={<Navigate to="/dashboard" replace />} />
                <Route path="/dashboard" element={<Dashboard />} />
                <Route path="/docs/browser-monitor" element={<DocsPage />} />
                <Route path="/gamification" element={<GamificationDashboard />} />
                <Route path="/alerting" element={<AlertingConfig />} />
                <Route path="/monitor/:id" element={<MonitorDetailsRouter />} />
                <Route path="/profile" element={<ProfilePage />} />
                <Route path="/admin/users" element={<AdminUsersPage />} />
                <Route path="*" element={<Navigate to="/dashboard" replace />} />
              </Routes>
            </Layout>
          )
        } />
      </Routes>
    </Router>
  );
};

export default AppRouter; 